import * as actionTypes from 'actions';

const initialState = {
  pageNumber: 1,
  rowCount: 0,
  loading: false,
  items: [],
  detectionLabelCounts: {},
  pageSize: 25,
  filterItemCount: null,
  filter: {
    search: '',
    scanTimeFrom: null,
    scanTimeTo: null,
    venue: null,
    detectionLabels: [],
    modelNames: [],
    detectionConfidenceMin: 0.4
  },
  venues: [],
  detectionLabels: {},
  modelNames: []
};

const PAGE = 'SCAN_LIST';

const scanListReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SCANS_PAGINATED_LIST_PENDING: {
      return {
        ...state,
        loading: true
      };
    }

    case actionTypes.SCANS_PAGINATED_LIST_FULFILLED: {
      return {
        ...state,
        ...action.payload.data.result,
        filter: {
          ...initialState.filter,
          ...action.payload.data.result.filter
        },
        loading: false
      };
    }

    case actionTypes.SET_SCAN_LIST_VENUES: {
      return {
        ...state,
        venues: action.payload.data.result
      };
    }

    case actionTypes.SET_SCAN_LIST_DETECTION_LABELS: {
      return {
        ...state,
        detectionLabels: action.payload.data.result
      };
    }

    case actionTypes.SET_SCAN_LIST_MODEL_NAMES: {
      return {
        ...state,
        modelNames: action.payload.data.result
      };
    }

    case actionTypes.SET_FILTER_VALUE: {
      let result;
      if (action.payload.pageName === PAGE) {
        result = {
          ...state,
          filter: {
            ...state.filter,
            ...action.payload.value
          }
        };
      } else {
        result = {
          ...state
        };
      }

      return result;
    }

    case actionTypes.SET_PAGE_SIZE: {
      let result;
      if (action.payload.pageName === PAGE) {
        result = {
          ...state,
          pageSize: action.payload.pageSize
        };
      } else {
        result = {
          ...state
        };
      }

      return result;
    }

    case actionTypes.CLEAR_FILTER_VALUES: {
      let result;
      if (action.payload.pageName === PAGE) {
        result = {
          ...state,
          filter: {
            ...initialState.filter,
            search: state.filter.search
          },
          filterItemCount: initialState.filterItemCount
        };
      } else {
        result = {
          ...state
        };
      }

      return result;
    }

    case actionTypes.GET_FILTER_VALUES_FULFILLED: {
      let result;
      if (
        action.payload.data.result &&
        action.payload.data.result.page === PAGE
      ) {
        result = {
          ...state,
          filterItemCount: action.payload.data.result.filter.filterItemCount,
          filter: {
            ...initialState.filter,
            ...action.payload.data.result.filter
          }
        };
      } else {
        result = {
          ...state
        };
      }

      return result;
    }

    default: {
      return state;
    }
  }
};

export default scanListReducer;
